import React from 'react';
import Password from './change-password/ChangePassword';
import LoginEmail from './login-email/LoginEmail';
import EditEmailInfo from './edit-email-info/EditEmailInfo';
import PersonalContactInfo from './personal-contact-info/PersonalContactInfo';
import { ProfileSC } from './MockProfile.style';
import { CustomHook } from 'utils/custom-hook';
import Authentication from './2FA-authentication/Authentication';
import { mockAreaCodeData, mockGet2fadata, mockUserUiDetails } from '../constant';
import Mockup from '../Mockup';

const MockProfile = () => {
  const { fixedTextboxWidth } = CustomHook();

  return (
    <Mockup>
      <ProfileSC>
        <Password width={fixedTextboxWidth} username={mockUserUiDetails.username} />
        <Authentication get2fadata={mockGet2fadata} areaCodeData={mockAreaCodeData} />
        <LoginEmail width={fixedTextboxWidth} username={mockUserUiDetails.username} />
        <EditEmailInfo width={fixedTextboxWidth} />
        <PersonalContactInfo width={{ width: '21.5rem' }} />
      </ProfileSC>
    </Mockup>
  );
};
export default MockProfile;
